import type { UseFormReturn } from 'react-hook-form';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ProfileDictionaryField } from './ProfileDictionaryField';
import { profileDictionaries } from './queries';
import type { ProfileField } from './types';

export interface ProfileCaseCharge { key: string; value: string }
export const ProfileCaseCharges = ({ odrnumber, form, field, charges, disabled, limit = 49, onAdd, onRemove }: {
  odrnumber: number; form: UseFormReturn<Record<string, string>>; field: ProfileField; charges: ProfileCaseCharge[]; disabled: boolean;
  onAdd: (value: string) => void; onRemove: (key: string) => void;
  limit?: number;
}) => {
  const value = form.watch('__chargeDraft')?.trim() ?? '';
  return <fieldset id="profile-case-new-charges" className="space-y-3 rounded border p-3">
    <legend className="px-1 font-medium">New charges</legend>
    <ProfileDictionaryField odrnumber={odrnumber} entity="charges" field={{ ...field, required: false }} inputName="__chargeDraft"
      query={profileDictionaries['charges.charge']} form={form} disabled={disabled} />
    <Button id="profile-case-charge-add" type="button" variant="outline" disabled={disabled || !value || charges.length >= limit || charges.some(charge => charge.value === value)}
      onClick={() => { onAdd(value); form.setValue('__chargeDraft', ''); }}><Plus aria-hidden="true" className="mr-2 h-4 w-4" />Add charge</Button>
    {!charges.length && <p className="text-sm text-muted-foreground">No new charges selected.</p>}
    {charges.map((charge, index) => <div key={charge.key} className="flex items-center justify-between gap-3"><span className="break-words">{charge.value}</span>
      <Button id={`profile-case-charge-${charge.key}-remove`} type="button" variant="outline" disabled={disabled} onClick={() => onRemove(charge.key)}>
        <Trash2 aria-hidden="true" className="mr-2 h-4 w-4" />Remove new charge {index + 1}
      </Button>
    </div>)}
  </fieldset>;
};
